<!-- poor man's pie menu -->
<script>
    import Vue from "vue";

    export default {
        name: "NoteRow",
        props: {
            note: Object,
        },

        methods: {
            copyField(field) {
                this.$emit("onCopy", this.note, field);
            },
            editNote() {
                this.$emit("onEdit", this.note);
            },
        },
    };
</script>

<template>
    <div class="note-row">
        <div>
            <div class="note-title" v-if="note.title">
                {{ note.title }}
            </div>
            <div class="notes-field">
                {{ note.description }}
            </div>
        </div>

        <div>
            <button class="button" @click.prevent.stop="editNote()">
                Edit
            </button>
        </div>
    </div>
</template>



<style lang="scss">
    .note-row {
        text-decoration: none;
        margin: 20px;
        padding: 20px;
        border: 2px solid transparent;
        display: flex;

        & > div:first-child {
            flex-grow: 1;
        }

        button {
            margin-left: 1em;
        }

        .note-title {
            margin-bottom: 1em;
            font-weight: 500;
        }

        .notes-field {
            position: relative;
            white-space: pre-line;
        }

        &.current {
            border: 2px solid $control;
            border-radius: 5px;
            background: #e8f0fe;
        }
    }
</style>
